import { render } from "./Error_404.vue?vue&type=template&id=01edc462&scoped=true"
import script from "./Error_404.vue?vue&type=script&lang=js"
export * from "./Error_404.vue?vue&type=script&lang=js"

import "./Error_404.vue?vue&type=style&index=0&id=01edc462&scoped=true&lang=scss"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01edc462"]])

export default __exports__